import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, toRefs, watch, ref } from "vue";
import { loadFieldSettings }        from "@ui/mixins/FieldSettings";


export default /*#__PURE__*/_defineComponent({
  props: {
        modelValue: {
            required: true
        },
        field:      {
            required: true
        }
    },
  emits: [ 'update:modelValue' ],
  setup(__props, { emit }) {

const props = __props


const { modelValue, field }                                   = toRefs( props );
const { getInputType, getInputTypeExtras, getInputTypeValue } = loadFieldSettings();


const input = ref( null );

onMounted( (): void => {
    input.value =  field.value.defaultValue || field.value.value || null;
} );

watch( () => input.value, ( v ) => {
    if ( v === modelValue.value ) return;

    emit( 'update:modelValue', v );
}, { deep: true } );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getInputType)(_unref(field).field)), {
    modelValue: input.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
    field: {
                    ..._unref(getInputTypeExtras)( { ..._unref(field), type: _unref(field).field || _unref(field).type } ),
                    value: input.value || _unref(field).defaultValue || _unref(field).value || null,
                    textAlign: _unref(field).meta.textAlign || 'left',
                    required: !!_unref(field).meta.required || false,
                    attribute: _unref(field).dbKey,
                    name: _unref(field).dbKey,
                    label: _unref(field).label,
                    stacked: _unref(field).stacked,
                    placeholder: _unref(field).meta.placeholder || _unref(field).label,
                    helper: _unref(field) && _unref(field).meta && _unref(field).meta.helper ? _unref(field).meta.helper : null,
                    extraAttributes: { ...( _unref(field) && _unref(field).meta && _unref(field).meta.attributes ? _unref(field).meta.attributes : {} ), autocomplete: _unref(field).attribute, ..._unref(field).attributes || {} }
                }
  }, null, 8, ["modelValue", "field"]))
}
}

})